<template>
  <div class="p-c-r" ref="activity_scroll" @scroll="activityScroll">
    <div class="p-o-menu-main">
        <ul class="p-o-menu">
            <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">视频回看</li>
            <li @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">移液技巧与应用</li>
        </ul>
    </div>
    <!-- pdf -->
    <h3 class="h3-title" v-show="menuType == '2'"><span>资料下载</span></h3>
    <product-shopping v-show="menuType == '2'" :productMaterial="productMaterial"></product-shopping>
    <!-- 视频 -->
    <h3 class="h3-title" v-show="menuType == '2'"><span>相关视频</span></h3>
    <new-pro-video :productVideo="productVideo" @videoChange="videoChange"></new-pro-video>
    <footerLine></footerLine>
    <!-- 观看视频 -->
    <video-play ref="videoPlay"></video-play>
  </div>
</template>

<script>
import { getProBindList } from '@/api/centrifuge'
import newProVideo from '@/components/new-pro-video.vue'
import videoPlay from '@/components/videoPlay'
import { centrifugeRecord } from '@/libs/common'
import footerLine from '@/components/footerLine'
export default {
    components: {
        productShopping: () => import('@/components/product-shopping'),
        newProVideo,
        videoPlay,
        footerLine
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            menuType: '1',
            page: 1,
            productVideo: [],
            productMaterial: [],
            moduleType: '8'
        }
    },
    created() {
        this.getProList()
    },
    methods: {
        getProList() {
            let para = {
                module: this.moduleType,
                type: this.menuType,
                page: this.page,
                cid: 0
            }
            getProBindList(para).then(res => {
                this.last_page = res.data.last_page
                if (this.menuType == '1') {
                    this.productVideo.push(...res.data.data)
                } else {
                    this.productMaterial.push(...res.data.data)
                    console.log('绑定列表',this.productMaterial);
                    if(res.data.data.length <= 10) {
                        this.page = 1
                        para.type = '1'
                        para.page = this.page
                        getProBindList(para).then(res => {
                            this.productVideo.push(...res.data.data)
                            this.last_page = res.data.last_page
                        })
                    }
                }
                
            })
            
        },
        handleMenu(type) {
            this.page = 1
            this.menuType = type
            type == '1' ? this.moduleType = '8': this.moduleType = '9'
            this.productVideo = []
            this.productMaterial = []
            this.getProList()
            let para = {
                type: type == '1'? 30 : 31, // 30 视频回看 31 移液技巧与应用
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para)
        },
        videoChange(item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.p-c-r {
    height: 100vh;
    overflow: auto;
}
.p-o-menu-main {
    display: flex;
    justify-content: center;
    margin-top: rem(12);
    margin-bottom: rem(20);
    .p-o-menu {
        width: rem(343);
        height: rem(30);
        display: flex;
        justify-content: center;
        // align-items: center;
        border-radius: 4px;
        color: #6CC5DB;
        border: 1px solid #6C94DB;
        li {
            flex: 1;
            line-height: rem(30);
            text-align: center;
        }
        .active {
            color: #fff;
            background-color: #6CC5DB;
            border-radius: 4px;
        }
    }
}
</style>